import React from 'react'
import userIcon from "../../assets/GlobalAssets/SetUpIcons/UserIcon.svg"
import teamIcon from "../../assets/GlobalAssets/SetUpIcons/SaleIcon.svg"
import departmentIcon from "../../assets/GlobalAssets/SetUpIcons/DepartmentIcon.svg"


import procurmentIcon from "../../assets/GlobalAssets/UserInfoIcons/PropertyProcurementIcon.svg"
import hrIcon from "../../assets/GlobalAssets/UserInfoIcons/HRIcon.svg"
import accountIcon from "../../assets/GlobalAssets/UserInfoIcons/accountIcon.svg"
import geoIcon from "../../assets/GlobalAssets/UserInfoIcons/geoIcon.svg"
import taskIcon from "../../assets/GlobalAssets/UserInfoIcons/taskIcon.svg"
import glfunnelIcon from "../../assets/GlobalAssets/UserInfoIcons/GlFunnelIcon.svg"

const GlobalImages = {
    userIcon,
    teamIcon,
    departmentIcon,

    procurmentIcon,
    hrIcon,
    accountIcon,
    geoIcon,
    taskIcon,
    glfunnelIcon

}

export default GlobalImages
